export default "### Resume my existing purchase\n";